var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82869 3.47331L12.422 11.788M13.3334 8.66664C13.3334 12 11 13.6666 8.22669 14.6333C8.08146 14.6825 7.92371 14.6802 7.78002 14.6266C5.00002 13.6666 2.66669 12 2.66669 8.66664V3.99997C2.66669 3.82316 2.73693 3.65359 2.86195 3.52857C2.98697 3.40355 3.15654 3.33331 3.33335 3.33331C4.66669 3.33331 6.33335 2.53331 7.49335 1.51997C7.63459 1.39931 7.81426 1.33301 8.00002 1.33301C8.18578 1.33301 8.36545 1.39931 8.50669 1.51997C9.67335 2.53997 11.3334 3.33331 12.6667 3.33331C12.8435 3.33331 13.0131 3.40355 13.1381 3.52857C13.2631 3.65359 13.3334 3.82316 13.3334 3.99997V8.66664Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTeams);
export default __webpack_public_path__ + "static/media/sidebar-teams.c776f181cb96d2bff2ac4b463be4e249.svg";
export { ForwardRef as ReactComponent };